import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';

const initialState = {
  loading: false,
  showOpen: false,
  saldoParticipante: 0,
  idTemporario: 0,
  typeRedemption: '',
  isEditModal: false,
  subSegmento: '',
  endereco: {
    rua: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
  },
  tableProduct: [],
  modalProduct: {
    nomeProduto: '',
    quantidade: 0,
    valor: 0,
    descricao: '',
  },
  valorTotalProdutos: 0,
  walletParticipant: [],
  dataParticipant: {},
  loadingBalanceParticipant: false,
  dataBalanceParticipant: {},
  dataParticipantSegment: {},
  loadingDataUserInfos: false,
  dataUserInfos: {},
  hierarchyShipping: {},
  dataCategories: [],
  dataSubCategories: [],
};

export const loadRedemptionCategories = createAsyncThunk(
  'spotNewSolicitationSlice/loadCategorias',
  async (_, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await redemptionsApiClient.get(`/Category`, {
      headers,
    });
    return data;
  }
);
export const loadRedemptionSubCategories = createAsyncThunk(
  'spotNewSolicitationSlice/loadSubCategorias',
  async ({ id }, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await redemptionsApiClient.get(
      `/Category/SubCategory?Categoryid=${id}`,
      {
        headers,
      }
    );
    return data;
  }
);

export const loadUserInfos = createAsyncThunk(
  'spotNewSolicitationSlice/loadUserInfos',
  async (payload) => {
    const { data: dataUsername } = await redemptionsApiClient.get(
      `/Syngenta/${payload.username}`,
      {
        headers: payload.headers,
      }
    );

    const { data: dataBalance } = await redemptionsApiClient.get(
      `/Participant/balance?participantId=${dataUsername.id}&username=${payload.username}`,
      {
        headers: payload.headers,
      }
    );

    const { data: dataSubSegmento } = await redemptionsApiClient.get(
      `/Syngenta/Participant?username=${payload.username}`,
      {
        headers: payload.headers,
      }
    );

    return {
      dadosUsuario: dataUsername,
      dadosCarteira: dataBalance,
      dadosSubSegmento: dataSubSegmento,
    };
  }
);

export const calculateShipping = createAsyncThunk(
  'spotNewSolicitationSlice/calculateShipping',
  async (payload, { getState }) => {
    const { user } = getState().oidc;
    const config = {
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      Authorization: `Bearer ${user.access_token}`,
      username: user.profile.username || user.profile['custom:login'],
    };
    const { data } = await redemptionsApiClient.post(
      `/Product/CalculateShipping`,
      payload,
      { headers: config }
    );

    return data;
  }
);
export const sendHierarchySolicitation = createAsyncThunk(
  'spotNewSolicitationSlice/sendHierarchySolicitation',
  async (payload, { getState }) => {
    const { user } = getState().oidc;
    const config = {
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      Authorization: `Bearer ${user.access_token}`,
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await redemptionsApiClient.post(
      `/Redemption/Hierarchy`,
      payload,
      { headers: config }
    );

    return data;
  }
);

export const loadWallet = createAsyncThunk(
  'spotNewSolicitationSlice/loadWallet',
  async (payload) => {
    const { data } = await redemptionsApiClient.get(
      `/Syngenta/Wallet?username=${payload.username}`,
      {
        headers: {
          ...payload,
        },
      }
    );
    return data;
  }
);

const spotNewSolicitationSlice = createSlice({
  name: 'spotNewSolicitationSlice',
  initialState: initialState,
  reducers: {
    setOpenModal: (state, action) => {
      state.showOpen = action.payload;
    },
    setIsEdit: (state, action) => {
      state.isEditModal = action.payload;
    },
    editProduct: (state, action) => {
      const index = state.tableProduct.findIndex(
        (product) => product.id === action.payload.id
      );
      state.tableProduct[index] = action.payload;
    },
    setValorTotalProdutos: (state, action) => {
      state.valorTotalProdutos = action.payload;
    },

    addProduct: (state, action) => {
      state.tableProduct.push(action.payload);
    },
    deleteProduct: (state, action) => {
      state.tableProduct = state.tableProduct.filter(
        (product) => product.id !== action.payload
      );
    },
    setModalProduct: (state, action) => {
      state.modalProduct = action.payload;
    },
    setInitialModalProduct: (state) => {
      state.modalProduct = {
        nomeProduto: '',
        quantidade: '',
        valor: '',
        descricao: '',
      };
    },
    setIdTemporario: (state, action) => {
      state.idTemporario = action.payload;
    },
    setTypesRedemption: (state, action) => {
      state.typeRedemption = action.payload;
    },

    setResetDataParticipant: (state) => {
      state.dataParticipant = {};
      state.tableProduct = [];
    },
    setResetSubCategories: (state) => {
      state.dataSubCategories = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadUserInfos.pending, (state) => {
        state.loadingDataUserInfos = true;

        state.dataParticipant = {};
        state.dataBalanceParticipant = {};
        state.saldoParticipante = 0;
      })
      .addCase(loadUserInfos.fulfilled, (state, action) => {
        //
        const defaultZipCode = '00000000';
        const unspecifiedCities = [
          'Nao Informado',
          'Não Informado',
          'Não informado',
        ];

        const { city = '', zipCode = defaultZipCode } =
          action.payload?.dadosUsuario?.address || {};

        state.dataParticipant = {
          ...action.payload.dadosUsuario,
          email: action.payload.dadosUsuario.emails[0].email,
          birthDate: action.payload.dadosUsuario.birthDate.split('T')[0],
          celular: action.payload.dadosUsuario.phones.map((phone) => {
            return {
              ddd: phone.areaCode,
              numero: phone.number,
            };
          }),

          city: unspecifiedCities.includes(city) ? '' : city,
          complement: action.payload.dadosUsuario.address?.complement,
          district: action.payload.dadosUsuario.address?.district,
          number: action.payload.dadosUsuario.address?.number,
          state: action.payload.dadosUsuario.address?.state,
          street: action.payload.dadosUsuario.address?.street,
          zipCode: zipCode !== defaultZipCode ? zipCode : '',
        };

        state.saldoParticipante = action.payload.dadosCarteira.pointsValue;
        state.subSegmento = action.payload.dadosSubSegmento.subSegmentoCrop;

        state.loadingDataUserInfos = false;
      })
      .addCase(loadUserInfos.rejected, (state) => {
        state.loadingDataUserInfos = false;
      })

      .addCase(loadWallet.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadWallet.fulfilled, (state, action) => {
        state.loading = false;
        state.walletParticipant = action.payload;
      })
      .addCase(loadWallet.rejected, (state) => {
        state.loading = false;
      })
      .addCase(calculateShipping.pending, (state) => {
        state.loading = true;
      })
      .addCase(calculateShipping.fulfilled, (state, action) => {
        state.loading = false;
        state.hierarchyShipping.total = action.payload.total;
        state.hierarchyShipping.undeliveredProducts =
          action.payload.undeliveredProducts;
      })
      .addCase(calculateShipping.rejected, (state) => {
        state.loading = false;
      })
      .addCase(loadRedemptionCategories.pending, (state) => {
        state.loadingRedemptionCategories = true;
      })
      .addCase(loadRedemptionCategories.fulfilled, (state, action) => {
        state.loadingRedemptionCategories = false;
        state.dataCategories = action.payload;
      })
      .addCase(loadRedemptionCategories.rejected, (state) => {
        state.loadingRedemptionCategories = false;
      })
      .addCase(loadRedemptionSubCategories.pending, (state) => {
        state.loadingSubCategories = true;
      })
      .addCase(loadRedemptionSubCategories.fulfilled, (state, action) => {
        state.loadingubCategories = false;
        state.dataSubCategories = action.payload;
      })
      .addCase(loadRedemptionSubCategories.rejected, (state) => {
        state.loadingubCategories = false;
      });
  },
});

export const {
  setOpenModal,
  addProduct,
  deleteProduct,
  setIdTemporario,
  editProduct,
  setModalProduct,
  setInitialModalProduct,
  setValorTotalProdutos,
  setIsEdit,
  setTypesRedemption,
  setResetDataParticipant,
  setResetSubCategories,
} = spotNewSolicitationSlice.actions;
export default spotNewSolicitationSlice.reducer;
